import { useTranslation } from "react-i18next";
import { List, useDynamicRowHeight } from "react-window";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import { calculateVirtualizedContainerHeight } from "components/Filters/functions";

import { useListCompanies } from "../../hooks";
import { ListCompaniesProps } from "../../types";
import RowComponent from "./RowComponent";

const ListCompanies = ({ searchValue }: ListCompaniesProps) => {
    const { gray200, textPlaceholder } = colors;

    const { t } = useTranslation();

    const {
        allCompanies,
        companyFilteredValues,
        companiesCount,
        sendToQueryParams,
        resetFilterParams
    } = useListCompanies(searchValue);

    const rowHeight = useDynamicRowHeight({
        defaultRowHeight: 48
    });

    const containerHeight = calculateVirtualizedContainerHeight(
        companiesCount,
        9,
        rowHeight
    );

    return (
        <>
            {searchValue.length > 0 && companiesCount === 0 ? (
                <div
                    css={css({
                        padding: "12px 16px",
                        color: textPlaceholder,
                        fontSize: "14px",
                        lineHeight: "24px",
                        letterSpacing: "0.1px"
                    })}
                >
                    {t("Table##empty table##no results found##title")}
                </div>
            ) : (
                <div
                    css={css({
                        height: `${containerHeight}px`
                    })}
                >
                    <List
                        rowComponent={RowComponent}
                        rowCount={companiesCount}
                        rowHeight={rowHeight}
                        rowProps={{
                            query: searchValue,
                            companies: allCompanies,
                            sendToQueryParams
                        }}
                        overscanCount={5}
                    />
                </div>
            )}

            <div
                css={css({
                    display: "flex",
                    padding: "7px 16px 16px 16px",
                    borderTop: `1px solid ${gray200}`
                })}
            >
                <TextLink
                    size={TEXT_LINK_SIZES.Small}
                    isDisabled={companyFilteredValues.length < 1}
                    onClick={() => resetFilterParams(true)}
                >
                    {t("Button##clear all")}
                </TextLink>
            </div>
        </>
    );
};

export default ListCompanies;
